.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
}

/* The shared Card, as the page's one column. */
.card {
  width: 100%;
  max-width: 420px;
  text-align: center;
}

.logo {
  display: block;
  width: 64px;
  height: 64px;
  margin: 0 auto var(--space-4);
}

.iconWrapper {
  margin-bottom: var(--space-4);
}

.icon {
  width: 48px;
  height: 48px;
  color: var(--success);
}

.title {
  font-family: "Raleway", sans-serif;
  font-size: var(--text-3xl);
  font-weight: var(--font-semibold);
  color: var(--text);
  margin-bottom: var(--space-4);
}

.message {
  color: var(--text);
  font-size: var(--text-md);
  line-height: var(--leading-relaxed);
  margin-bottom: var(--space-6);
}

.button {
  --kui-btn-font-family: "Raleway", sans-serif;
  --kui-btn-font-size: var(--text-md);
  --kui-btn-font-weight: var(--font-semibold);
  --kui-btn-padding: var(--space-3) var(--space-6);
  --kui-btn-border-width: 0;
  --kui-btn-radius: var(--radius-md);
  --kui-btn-transition: var(--transition-base);
}
